import { z } from "zod";

/**
 * Shared search param schema for paginated list pages with a text query.
 * Used by: /data/sets, /realassets, and any future list page.
 */
export const paginatedListSchema = z.object({
  query: z.string().optional().default(""),
  page: z.number().optional().default(1),
  size: z.number().optional().default(10),
});

export const paginatedListDefaults = paginatedListSchema.parse({});
